const Reports = {
  getReports: () => `/Reports/CashFlowByProcessDate`,
  getNewReports: () => `/Reports/GetReport`,
  getPaymentMethods: () => `/Reports/ClientPaymentMethod`,
  getCashFlowType: () => `/Reports/CashFlowType`,
  getUsersFromAgency: () => `/AgencyUser/UsersFromAgency`,
  getAllAgencies: () => `/Agency/AdminGetAllAgencies`,
};

export default Reports;
